module.exports = __webpack_public_path__ + "img/043.c2dd37b2.jpeg";